/*********************************************************************
* © Copyright IBM Corp. 2024
*********************************************************************/
import React from 'react'
import classNames from 'classnames'
import {ZIndexProps} from './model'
import {getSimpleCellItemComponent} from './getSimpleCellItemComponent'
import {AuditEvent} from '../ConfigurationList'
import styles from '../style/index.css'
import {knownAreas} from '../ConfigurationAuditList/areas'
import intl from '../utils/intl/intl'

export interface AreaHeaderProps extends ZIndexProps {
  area?: string | null
  onAreaChange?: (area?: string | null) => void
}

function getDisplayName(area) {
  // nosemgrep: eslint.detect-object-injection
  return knownAreas[area] || area
}

export const AreaHeader = () => {
  return (
    <div className={classNames(styles['log__header'])}>
      <div
        className={classNames(styles['log__header__name'], styles['log__header__name--disabled'])}
      >
        {intl.formatMessage('Areas')}
      </div>
    </div>
  )
}

export const AreaRow = getSimpleCellItemComponent<AuditEvent>((item) => getDisplayName(item.area))
